module.exports = __webpack_public_path__ + "530516b9fe16b40eb3794a51426b6ce8.MP3";